<template>
  <div class="layout-cart-checkout">
    <form @submit.prevent="submit">
      <div class="param">
        <div class="subtitle param-name">way to pay</div>
        <div class="switch">
          <div
            v-for="(payment, index) in order.paymentWays"
            :key="index"
            :class="[{ active: payment.value === order.payment }]"
            class="option"
            @click="order.payment = payment.value"
          >
            <div class="subtitle">
              {{ payment.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="param address-zip">
        <div class="address">
          <div class="subtitle param-name">Delivery address</div>
          <input type="text" placeholder="Delivery address" />
        </div>
        <div class="zip">
          <div class="subtitle param-name">Zip code</div>
          <input type="text" placeholder="Zip code" />
        </div>
      </div>
      <div class="param contacts">
        <div class="subtitle param-name">Contact information</div>
        <div class="contact-inputs">
          <input required name="name" type="text" placeholder="name" />
          <input required name="phone" type="phone" :placeholder="mask" />
          <input required name="email" type="email" placeholder="email" />
          <textarea name="comment" rows="2" placeholder="comment"></textarea>
        </div>
      </div>
      <div class="param promos">
        <input id="promos" v-model="promos" type="checkbox" />
        <label for="promos" class="small-text">
          <slot name="promos"></slot>
        </label>
      </div>
      <div v-if="promos" class="param">
        <label class="promo-option">
          <input id="email" v-model="email" type="checkbox" />
          <div class="xxs-title">
            Email
          </div>
        </label>
        <label class="promo-option">
          <input id="sms" v-model="sms" type="checkbox" />
          <div class="xxs-title">
            SMS
          </div>
        </label>
        <label class="promo-option">
          <input id="post" v-model="post" type="checkbox" />
          <span class="xxs-title">Post</span>
        </label>
      </div>
      <div class="button">
        <ui-button fill>checkout</ui-button>
        <div class="agree">
          <slot name="agreement"></slot>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import uiButton from '@/components/ui/ui-button'
export default {
  components: {
    uiButton
  },
  props: {
    order: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      promos: false,
      email: true,
      sms: true,
      post: false,
      mask: '+7 (___) ___-__-__'
    }
  },
  mounted() {
    const input = this.$el.querySelector('input[type="phone"]')
    if (input) {
      const Inputmask = require('inputmask').default
      const im = new Inputmask({
        mask: this.mask.split('_').join('9'),
        showMaskOnHover: false,
        showMaskOnFocus: true
      })
      im.mask(input)
    }
  },
  methods: {
    submit() {}
  }
}
</script>

<style lang="scss" scoped>
.layout-cart-checkout {
  display: flex;
  flex-direction: column;
  form {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }
}
.switch {
  display: flex;
  border: solid 1px rgba(0, 0, 0, 0.2);
  & > * {
    transition: 0.5s;
    flex-grow: 1;
    text-align: center;
    padding: 0.5em;
    &:not(:last-child) {
      border-right: solid 1px rgba(0, 0, 0, 0.1);
    }
    cursor: pointer;
    &.active {
      background: var(--color);
      color: #fff;
    }
  }
}
.param {
  margin-bottom: 2em;
  .param-name {
    font-weight: 600;
    margin-bottom: 0.5em;
  }
}
.address-zip {
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  grid-gap: 1em;
}
.contact-inputs {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 1em;
  & > * {
    text-transform: uppercase;
    &[name='name'],
    &[name='comment'] {
      grid-column: span 2;
    }
  }
  textarea {
    padding: 0.5em;
    height: auto;
  }
}
.button {
  display: flex;
  align-items: center;
  margin-top: auto;
  button {
    width: 15em;
    max-width: 100%;
  }
  .agree {
    font-size: 0.75em;
    // width: 10em;
    max-width: 100%;
    margin-left: 2em;
    a {
      text-decoration: underline;
    }
  }
}
.promo-option {
  display: inline-flex;
  align-items: center;
  margin-right: 0.5em;
  border: solid 1px rgba(0, 0, 0, 0.1);
  padding: 0.4em;
  padding-right: 1.5em;
  input {
    margin-right: 0.5em;
  }
}
.promos {
  input {
    margin-right: 0.5em;
  }
}
</style>
